/*
 * The set's image lightbox. Lifted out of snippets/hoopers-bundle-offer with
 * the rest of its JS so the snippet is markup and style only.
 *
 * It hides every fixed-position element while open — chat bubbles, cookie bars,
 * the sticky buy bar — because they float above a full-screen overlay and
 * would otherwise sit on top of the photograph the shopper opened.
 */
(function () {
  if (window.hbLightbox) return;

  var lb = null, imgs = [], idx = 0, hiddenEls = [];

  function hideFloaters() {
    hiddenEls = [];
    var cand = [];
    Array.prototype.forEach.call(document.body.children, function (c) {
      if (c === lb) return;
      cand.push(c);
      Array.prototype.forEach.call(c.children, function (g) { cand.push(g); });
    });
    cand.forEach(function (el) {
      try {
        if (el === lb || lb.contains(el) || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden') {
          hiddenEls.push([el, el.style.getPropertyValue('visibility'), el.style.getPropertyPriority('visibility')]);
          el.style.setProperty('visibility', 'hidden', 'important');
        }
      } catch (err) {}
    });
  }

  function showFloaters() {
    hiddenEls.forEach(function (p) {
      if (p[1]) p[0].style.setProperty('visibility', p[1], p[2] || '');
      else p[0].style.removeProperty('visibility');
    });
    hiddenEls = [];
  }

  function show(i) {
    if (!imgs.length) return;
    idx = (i + imgs.length) % imgs.length;
    lb.querySelector('.hb-lb__img').src = imgs[idx];
    lb.querySelector('.hb-lb__count').textContent = (idx + 1) + ' / ' + imgs.length;
    var navs = lb.querySelectorAll('.hb-lb__nav');
    for (var n = 0; n < navs.length; n++) navs[n].style.display = imgs.length > 1 ? '' : 'none';
  }

  function close() {
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    showFloaters();
  }

  window.hbLightbox = function () {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'hb-lb';
    lb.hidden = true;
    lb.innerHTML = '<button type="button" class="hb-lb__close" aria-label="סגירה">✕</button>' +
      '<button type="button" class="hb-lb__nav hb-lb__prev" aria-label="הקודם">‹</button>' +
      '<img class="hb-lb__img" alt="">' +
      '<button type="button" class="hb-lb__nav hb-lb__next" aria-label="הבא">›</button>' +
      '<div class="hb-lb__bar"><span class="hb-lb__ttl"></span><span class="hb-lb__count"></span>' +
      '<a class="hb-lb__link" target="_blank" rel="noopener" hidden>לדף המוצר</a></div>';
    document.body.appendChild(lb);

    lb.querySelector('.hb-lb__close').addEventListener('click', close);
    lb.querySelector('.hb-lb__prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.hb-lb__next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx + 1);
      if (e.key === 'ArrowRight') show(idx - 1);
    });

    lb.open = function (list, title, url) {
      imgs = list;
      lb.querySelector('.hb-lb__ttl').textContent = title || '';
      var a = lb.querySelector('.hb-lb__link');
      if (url) { a.href = url; a.hidden = false; } else { a.hidden = true; }
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      hideFloaters();
      show(0);
    };
    return lb;
  };
})();
